// extracted by mini-css-extract-plugin
module.exports =  {"icon":"WpZtb3x4qLqk7K4pXyC9"};